import React, {useContext} from "react";

// Utils
import {AuthContext} from "../contexts/auth.js";

// Components
import TableRegions from "./regions/TableRegions.js";

// Style
import {Page} from "../style/components/general.js";

const Regions = () => {
  const {currentUser} = useContext(AuthContext);
  return (
    currentUser && (
      <Page>
        <TableRegions />
      </Page>
    )
  );
};

export default Regions;
